import { render, staticRenderFns } from "./IssueRecord.vue?vue&type=template&id=ab3aef5a&scoped=true&"
import script from "./IssueRecord.vue?vue&type=script&lang=js&"
export * from "./IssueRecord.vue?vue&type=script&lang=js&"
import style0 from "./IssueRecord.vue?vue&type=style&index=0&id=ab3aef5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3aef5a",
  null
  
)

export default component.exports